import type { ISODateTimeString } from '../BrandedTypes'
import type { SupportPerson } from '../SupportPerson'
import type { SupportSession } from '../SupportSession'

export const SUPPORT_API_PATHS = {
  getAllSupportPersonnel: 'support/personnel',
  getSupportSession: (sessionId: string) => `support/sessions/${sessionId}`,
  getAssignedSupportSessions: 'support/sessions/assigned',
  getRegisteredSupportSessions: 'support/sessions/started',
  getSupporSessionsHistory: (query?: GetSupporSessionsHistoryQueryParams) =>
    `support/sessions/history${query ? `?${new URLSearchParams(query).toString()}` : ''}`,
  createNewSupportSession: 'support/sessions',
  endSupportSession: (sessionId: string) => `support/sessions/${sessionId}/end`
}

export interface GetAllSupportPersonnelResponse {
  personnel: SupportPerson[]
}

export interface GetSupportSessionResponse {
  session: SupportSession
}

export interface GetAssignedSupportSessionRequest {
  sessions: SupportSession[]
}

export interface GetRegisteredSupportSessionRequest {
  sessions: SupportSession[]
}

export interface GetSupporSessionsHistoryRequest {
  sessions: SupportSession[]
}

export interface GetSupporSessionsHistoryQuery {
  status?: 'any' | 'active' | 'historical'
  from?: ISODateTimeString
  to?: ISODateTimeString
}

export type GetSupporSessionsHistoryQueryParams =
  | {
      status?: 'any' | 'active'
    }
  | {
      status: 'historical'
      from: ISODateTimeString
      to: ISODateTimeString
    }

export interface CreateNewSupportSessionRequest {
  /** The support session ID. */
  sessionId: string
  /** The unique identifier for the support user. */
  supportUserId: string
  /** Indicates whether tenant administrator privileges should be granted. */
  grantTenantAdmin: boolean
  /** The date and time from which the grant is effective. */
  grantFrom: ISODateTimeString
  /** The end date and time for the granted access. */
  grantTo: ISODateTimeString
  /** Optional comments provided with the request. */
  grantReason: string
}
